<template>
  <div>
    <div class="grid-content container">
      <!-- top标题状态栏-->
      <div class="float-layout overlay">
        <a-row type="flex" justify="space-around" align="middle">
          <a-col class="w12-pc"> <!--:span="4"-->
            <span>供应商当天负荷</span>
          </a-col>
          <a-col class="w7-pc"><!-- :span="1.5"-->
            <span>排产日期</span>
          </a-col>
          <a-col class="w81-pc"> <!-- :span="18"-->
            <a-date-picker v-model="queryParams.startDate" @change="onChange" />
          </a-col>
        </a-row>
      </div>
      <div class="content" id="ipage-chart-send" ref="send"></div>
    </div>
  </div>
</template>
<script>
import { lineVendorSearch } from "@/api/scp/productionScheduling/schedulingWorkbench.js"
import * as echarts from 'echarts';
import moment from 'moment'
export default {
	name: 'SchedulingInfoTable',
	components: {
	},
	data () {
		return {
			queryParams: {
				startDate: ''
			}
		}
	},
	mounted () {
		this.renderChart({
			xAxis: {
				type: 'category',
				data: []
			},
			grid: {
				top: '15%',
				left: '2%',
				right: '2%',
				bottom: '5%',
				containLabel: true
			},
			yAxis: {
				type: 'value'
			},
			series: [
				{
					data: [],
					type: 'line'
				}
			]
		})
	},
	methods: {
		setQueryParamsAndQuery (startDate) {
			this.onChange(moment(startDate))
		},
		renderChart (option) {
			const myChart = echarts.init(this.$refs.send);
			option && myChart.setOption(option);
		},
		onChange (val) {
			console.log(val)
			this.queryParams.startDate = val
			lineVendorSearch({
				startDate: val.format('YYYY-MM-DD')
			}).then(res => {
				console.log(res)
				this.renderChart({
					xAxis: {
						type: 'category',
						data: res.map(item => item.supplierName),
						axisLabel: {
							interval: 0 // 设置间隔为0，确保所有标签都显示出来
						}
					},
					grid: {
						top: '15%',
						left: '2%',
						right: '2%',
						bottom: '5%',
						containLabel: true
					},
					yAxis: {
						name: '%',
						type: 'value'
					},
					tooltip: {
						trigger: 'axis',
						valueFormatter: (value) => `${parseFloat(value.toFixed(4))}%`
					},
					series: [
						{
							data: res.map(item => item.lineLoad * 100),
							type: 'line'
						}
					]
				})
			})
		}
	}
}
</script>
<style lang="less" scoped>

.grid-content {
    width: 100%;
	border-radius: 4px;
	min-height: 36px;
	background: rgb(255, 255, 255);
}
.float-layout {
    z-index: 2;
}
.container {
  position: relative;
//   width: 300px;
//   height: 200px;
//   height: 200px;
  // width: 1000px
}

.overlay {
//   position: absolute;
  top: 0;
  left: 0;
  width: 100%;
//   height: 100%;
  z-index: 2; /* 设置较高的 z-index 值 */
}

.content {
  position: relative;
  z-index: 1; /* 设置较低的 z-index 值 */
  height: 250px;
//   width: 1000px
}
.w12-pc {
	width: 12%;
}
.w7-pc {
	width: 7%;
}
.w81-pc {
	width: 81%;
}
</style>
